import { ProtocolType } from '@hyperlane-xyz/utils';
export var ProviderType;
(function (ProviderType) {
    ProviderType["EthersV5"] = "ethers-v5";
    ProviderType["Viem"] = "viem";
    ProviderType["SolanaWeb3"] = "solana-web3";
    ProviderType["CosmJs"] = "cosmjs";
    ProviderType["CosmJsWasm"] = "cosmjs-wasm";
    ProviderType["GnosisTxBuilder"] = "gnosis-txBuilder";
})(ProviderType || (ProviderType = {}));
export const PROTOCOL_TO_DEFAULT_PROVIDER_TYPE = {
    [ProtocolType.Ethereum]: ProviderType.EthersV5,
    [ProtocolType.Sealevel]: ProviderType.SolanaWeb3,
    [ProtocolType.Cosmos]: ProviderType.CosmJsWasm,
};
//# sourceMappingURL=ProviderType.js.map